import { createNaturalPaperRotation } from '@blocksuite/affine-model';

import type { StickyNoteColor } from '../schemas/sticky-note-model.js';

const COLORS = ['yellow', 'pink', 'blue', 'green'] as const;

let previousColor = -1;
let previousPaperVariant = -1;

export type StickyNoteAppearance = {
  color: StickyNoteColor;
  paperVariant: number;
  pinOffset: number;
  pinOffsetY: number;
  pinRotation: number;
  rotation: number;
};

/** Creates one stable, natural-looking visual preset for a new sticky note. */
export function createStickyNoteAppearance(): StickyNoteAppearance {
  const colorCandidates = COLORS.map((_, index) => index).filter(
    index => index !== previousColor
  );
  const colorIndex =
    colorCandidates[Math.floor(Math.random() * colorCandidates.length)];
  previousColor = colorIndex;

  const paperCandidates = [0, 1, 2, 3].filter(
    variant => variant !== previousPaperVariant
  );
  const paperVariant =
    paperCandidates[Math.floor(Math.random() * paperCandidates.length)];
  previousPaperVariant = paperVariant;

  const angle = Math.random() * Math.PI * 2;
  const radius = Math.sqrt(Math.random());
  return {
    color: COLORS[colorIndex],
    paperVariant,
    // Uniform point inside a shallow, horizontally stretched top ellipse.
    pinOffset: Math.round(Math.cos(angle) * radius * 180) / 1000,
    pinOffsetY: Math.round(Math.sin(angle) * radius * 45) / 1000,
    pinRotation: Math.round((Math.random() * 12 - 6) * 10) / 10,
    rotation: createNaturalPaperRotation(),
  };
}
